import axios from 'axios';

const headers = { Authorization: `Bearer ${localStorage.getItem('USER_TOKEN')}` };

export const getRewardRequests = async () => {
    const { data } = await axios.get('/api/v1/reward-requests', { headers });
    return data.data;
};

export const updateRewardRequest = async (id, status) => {
    const { data } = await axios.put(`/api/v1/reward-requests/${id}`, { status }, { headers });
    return data.data;
};
